<template>
  <div class="grid">
    <loading
      :active="isLoadingModel"
      :can-cancel="true"
      color="#274461"
      :is-full-page="fullPage"
    ></loading>
    <div class="col-12">
      <div class="card">
        <div class="p-fluid formgrid grid">
            <div
            class="field col-12 md:col-2"
           
          >
          <span class="p-float-label">
                  <Dropdown
                    id="client_dropdown"
                    v-model="client_selected"
                    :options="client_dropdown"
                    :value="client_dropdown"
                    optionLabel="name"
                    filter
                    
                  ></Dropdown>
                  <label for="Client">{{ $t("client") }}</label>
                </span>
        </div>
          <div
            class="field col-12 md:col-2"
            
          >
            <FileUpload
              mode="basic"
              id="fileupload1"
              ref="fileupload1"
              :chooseLabel="$t('upload_user')"
              :maxFileSize="1000000"
              @change="fileuploaduser($event)"
            />
          </div>
          <div class="field col-12 md:col-12" style="margin-top: 1%">
            <DataTable
              :value="products"
              :loading="loading"
              :lazy="true"
              :rows="limit"
              :filters="filters"
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              :rowsPerPageOptions="[5, 10, 25]"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
              responsiveLayout="scroll"
              style="font-size: 12px"
              :rowHover="true"
              showGridlines
            >
              <template #empty>
                <b style="text-align: center">{{ $t("no_records_found") }}</b>
              </template>
              <template #header>
                <div
                  class="flex flex-column md:flex-row md:justify-content-between md:align-items-center"
                >
                  <h5 class="m-0">
                    <b> {{ $t("new_user_list") }}</b>
                  </h5>
                  {{ $t("total_record") }} : {{ this.products.length }}
                </div>
              </template>
              <Column
                field="first_name"
                headerStyle="min-width:10rem;"
                :header="$t('firstname')"
              >
                <template #body="{ data }">
                  <InputText
                    id="first_name"
                    type="text"
                    size="10"
                    v-model.trim="data.first_name"
                    required="true"
                    autofocus
                  />
                </template>
              </Column>
              <Column
                field="last_name"
                headerStyle="min-width:10rem;"
                :header="$t('lastname')"
              >
                <template #body="{ data }">
                  <InputText
                    id="last_name"
                    type="text"
                    size="10"
                    v-model.trim="data.last_name"
                    required="true"
                    autofocus
                  />
                </template>
              </Column>
              <Column
                field="mobile_number"
                headerStyle="min-width:10rem;"
                :header="$t('mobile')"
              >
                <template #body="{ data }">
                  <InputText
                    id="mobile_number"
                    type="text"
                    size="10"
                    v-model.trim="data.mobile_number"
                    required="true"
                    autofocus
                  />
                </template>
              </Column>
              <Column
                field="password"
                headerStyle="min-width:10rem;"
                :header="$t('password')"
              >
                <template #body="{ data }">
                  <InputText
                    id="password"
                    type="text"
                    size="10"
                    v-model.trim="data.password"
                    required="true"
                    autofocus
                  />
                </template>
              </Column>
              <Column
                field="email_id"
                headerStyle="min-width:10rem;"
                :header="$t('email')"
              >
                <template #body="{ data }">
                  <InputText
                    id="email"
                    type="email"
                    size="10"
                    v-model.trim="data.email_id"
                    required="true"
                    autofocus
                  />
                </template>
              </Column>
              <Column :header="$t('action')" headerStyle="min-width:2rem;">
                <template #body="slotProps">
                  <Button
                    icon="pi pi-trash"
                    class="p-button-rounded p-button-danger mt-2"
                    @click="confirmDeleteProduct(slotProps.data)"
                  />
                </template>
              </Column>
            </DataTable>
          </div>
          <div class="field col-12 md:col-4" style="margin-top: 1%"></div>
          <div class="field col-12 md:col-2" style="margin-top: 1%">
            <Button
              :label="$t('submit')"
              class="p-button-success mr-2"
              @click="submit_details"
              v-tooltip.bottom="$t('submit')"
            />
          </div>
          <div class="field col-12 md:col-2" style="margin-top: 1%">
            <Button
              :label="$t('reset')"
              class="p-button-danger mr-2"
              v-tooltip.bottom="$t('reset')"
              @click="reset_user"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { FilterMatchMode } from "primevue/api";
import JsonExcel from "vue-json-excel";
import apis from "@/apis";
import readXlsxFile from "read-excel-file";
import axios from "axios";
export default {
  data() {
    return {
      client_dropdown: [],
      client_selected: "",
      limit: 10,
      filters: {},
      products: [],
      status: "",
      isLoading: false,
      isLoadingModel: false,
      loading: false,
      fullPage: true,
      file_attachment: "",
      id: "",
      list: [],
      client_role_group: "",
      product: {},
      submitted: false,
    };
  },
  productService: null,
  computed: {
    currentLocale() {
      return this.$i18n.locale;
    },
  },
  async mounted() {
    await this.getClientMaster();
  },
  watch: {
    currentLocale() {
      this.getClientMaster(this.currentLocale);
    }
  },
  methods: {
    async getClientMaster() {
      var data = {};
      var promise = apis.getclientist(data);
      promise.then((response) => {
        //this.client_dropdown = response.data.data;

        //new
        const temp = response.data.data;
        if (temp.length > 0) {
          const locale = this.$i18n.locale;
          const selectedId = this.client_selected?._id;
          this.client_dropdown = temp.map((item) => ({
            name: locale === "en" ? item.name : item.name_mr,
            code: item.superset_id,
            _id: item._id,
          }));
          const matchedProduct = this.client_dropdown.find(
            (p) => p._id === selectedId
          );
          if (matchedProduct) {
            this.client_selected = matchedProduct;
          } 
      
        }
      });
    },
    confirmDeleteProduct(data) {
      this.$swal
        .fire({
          title: this.$t("confirm_action"),
          text: this.$t("confirm_delete"),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: this.$t("delete_button"),
          cancelButtonText: this.$t("cancel"),
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.products = this.products.filter(
              (item) => item.mobile_number != data.mobile_number
            );
            this.$swal.fire({
              title: this.$t("del"),
              text: this.$t("user_deleted"),
              icon: "success",
              confirmButtonText: this.$t("ok"),
            });
          }
        });
    },
    submit_details() {
        if (!this.client_selected?._id) 
        {
             this.$toast.add({
                severity: "error",
                summary: this.$t("error"),
                detail: this.$t("selectclient"),
                life: 3000,
                });
                return false;
        }
   
      if (
        this.products == [] ||
        this.products == null ||
        this.products == undefined ||
        this.products.length == 0
      ) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("atleast_one"),
          life: 3000,
        });
        return false;
      }
      for (var i = 0; i < this.products.length; i++) {
        if (this.products[i].mobile_number) {
          this.products[i].mobile_number =
            this.products[i].mobile_number.toString();
        }
      }
      var data = {
        user_details: this.products,
        client_id: this.client_selected?._id,
        user_id: localStorage.getItem("id"),
        lang: this.$i18n.locale,
      };
      this.isLoadingModel = true;
      var promise = apis.bulkuserupload_save(data);
      promise
        .then((responseapi) => {
          this.$toast.add({
            severity: "success",
            summary: this.$t("success"),
            detail: responseapi.data.message,
            life: 3000,
          });
          this.isLoadingModel = false;
          this.reset_user();
          this.$router.go(-1);
        })
        .catch((error) => {
          this.isLoadingModel = false;
          this.reset_user();
          this.$router.push({ name: "usermaster" });
        });
    },
    formatDate(year) {
      if (!year) {
        return "";
      }
      const date = new Date(year, 0, 1);
      const options = {
        weekday: "short",
        month: "short",
        day: "2-digit",
        year: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        timeZoneName: "short",
      };
      const formattedDate = date.toLocaleString("en-US", options);
      return formattedDate;
    },
    fileuploaduser(event) {
      const input = this.$refs.fileupload1;
      if (
        input.files[0].name.slice(
          (Math.max(0, input.files[0].name.lastIndexOf(".")) || Infinity) + 1
        ) == "xlsx"
      ) {
        readXlsxFile(input.files[0]).then((rows) => {
          for (var i = 1; i < rows.length; i++) {
            this.products.push({
              first_name: rows[i][0],
              last_name: rows[i][1],
              mobile_number: rows[i][2],
              password: rows[i][3],
              email_id: rows[i][4],
              _id: "0",
              sr_no: this.products.length + 1,
              status: "Active",
            });
          }
        });
      } else {
        alert("Please select valid file");
      }
    },
    initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },
    reset_user() {
        this.client_selected ="";
      this.product = {};
      this.products = [];
      this.submitted = false;
      this.status_dropdownItem = null;
      this.dropdownItem = null;
      this.state_dropdownItem = null;
      this.location_search = "";
      this.show_name = "Add";
      this.$refs.file_attachment.files = "";
      
    },
  },
  async created() {
    this.id = localStorage.getItem("id");
    this.client_id = localStorage.getItem("client_id");
    this.user_type = localStorage.getItem("user_key");
  },
  components: { downloadExcel: JsonExcel },
};
</script>
